import Obstacle from './Obstacle';

let coordItems;

export default class Spikes extends Obstacle {
  constructor({ game, player, values, road, enemies }) {
    super({
      game,
      player,
      values,
      road,
      name: 'spikes',
      enemies,
    });
    this._chance = 0.006;
    this.enemies = enemies;
  }
  get _areaValues() {
    const values = {
      width: this._road.part / this._scaleVlue,
      height: this.defaultHeight + (2 * this._player.defaultHeight),
    };
    values.offsetX = this.item.x === this.coords.minX ? 0 : -(values.width - this.width);

    return values;
  }
  _setRandomX() {
    coordItems = { ...this.coords };
    delete coordItems.middleX;

    for (let i = this.enemies.length - 1; i >= 0; i -= 1) {
      if (this.enemies[i].isActive) {
        if (this.enemies[i].item.x === this.enemies[i].coords.minX) {
          delete coordItems.maxX;
        } else if (this.enemies[i].item.x === this.enemies[i].coords.maxX) {
          delete coordItems.minX;
        }
      }
    }
    this._setX(coordItems);
  }
}



// WEBPACK FOOTER //
// ./src/js/Spikes.js